import { render, staticRenderFns } from "./ThreadRepliesSkeleton.vue?vue&type=template&id=7bf0a19a&scoped=true"
import script from "./ThreadRepliesSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreadRepliesSkeleton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ThreadRepliesSkeleton.vue?vue&type=style&index=0&id=7bf0a19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0a19a",
  null
  
)

export default component.exports